<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PzaYDr/tc-custom/9781937084721.jpg?1684975102210" alt="This image is the cover for the book The $7.50 Bunny That Changed the World"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The $7.50 Bunny That Changed the World
      </h1>
      <p class="bookDescription body article font2">
        <b>Winner of two 2013 Indie Next Generation Finalist awards,</b><br/><br/> "The $7.50 Bunny That Changed the World" is the story of Flopsy Parker who was dropped off at a North Carolina shelter in the fall of 2010. By 2011, after he had trained his mother Gretta to be his ghost writer, he was inspiring people on Facebook with his message of adoption and helping other rabbits around the world that needed homes.<br/><br/> Written for children from ages 8 - 12, this delightful, heartwarming, and real-life story, as told from Flopsy Parker's point of view, is sure to tweak bunny bones in children of all ages.<br/><br/> "The $7.50 Bunny That Changed the World" is a tribute to his life, the people he inspired, and proof that even the smallest of creatures can live the biggest of lives.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gretta Parker
      </h2>
      
      <p class="authorDescription body article">Gretta Parker has written for the Examiner, Triad Happy Tails Magazine, and edited for Polo Ralph Lauren. She self-published her debut book "The Easter Bunny that Grew Up" about her beloved rabbit Flopsy Parker that captured hearts around the world with his message of rabbit adoptions. The book also celebrates Flopsy's life in pictures and expands on the lessons he taught her. She is the mother of five bunnies, all adopted from shelters; and she runs Baskets for Bunnies, Inc., a nonprofit that provides rescues with supplies</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BQB Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?44ea0b8c